module.exports = __webpack_public_path__ + "img/chevron-right-solid.44f387e2.svg";